import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, IdCardIcon } from 'lucide-react';
const credentials = ['Resident', 'Pool', 'Registered activity', 'Facility access', 'Booking'];
export function CardAccess() {
  return <section aria-labelledby="card-access-title" className="mt-14 grid gap-6 rounded-3xl border border-slate-200 bg-white p-6 sm:p-8 lg:grid-cols-[minmax(0,1fr)_minmax(0,320px)] lg:items-center" data-id="element-1371" data-mp="b0jdcda56dxj">
      <div data-id="element-1372" data-mp="11tscbmy8dd2">
        <h2 id="card-access-title" className="text-2xl font-extrabold tracking-tight text-ville-navy" data-id="element-1373" data-mp="11lh0o6h5g3z">
          My digital card
        </h2>
        <p className="mt-2 max-w-xl text-[15px] leading-relaxed text-slate-600" data-id="element-1374" data-mp="3o7ulgpklwdmw">
          Your card gets you into your activities and participating facilities. No separate recreation card is needed.
        </p>
        <ul className="mt-4 flex flex-wrap gap-2" data-id="element-1375" data-mp="1mfy8rcmpcxqj">
          {credentials.map(credential => <li key={credential} className="rounded-full bg-slate-100 px-3 py-1 text-xs font-bold text-ville-navy" data-id="element-1376" data-mp="1hjhkmifi6jdg">
              {credential}
            </li>)}
        </ul>
        <Link to="/my-card" className="mt-6 inline-flex items-center gap-2 text-sm font-bold text-ville-indigo hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-1377" data-mp="1r6198hiad6p3">
          View my card
          <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-1378" data-mp="25tchoaj68akz" />
        </Link>
      </div>

      <div className="rounded-2xl bg-ville-navy p-5 text-white" data-id="element-1379" data-mp="2at78ke2y5061">
        <div className="flex items-center justify-between" data-id="element-1380" data-mp="2auidwic1ifz9">
          <span className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.14em]" data-id="element-1381" data-mp="1w301svmax5l6">
            <IdCardIcon className="h-4 w-4 text-ville-lime" aria-hidden="true" data-id="element-1382" data-mp="211kzooe2zd6g" />
            Digital card
          </span>
          <span className="text-xs font-semibold text-white/60" data-id="element-1383" data-mp="2or5in7a8iafq">Bonnyville</span>
        </div>
        <p className="mt-6 text-lg font-extrabold" data-id="element-1384" data-mp="2tkhz2u4rfaxe">Bryon Mickelson</p>
        <p className="font-mono text-sm tracking-[0.2em] text-white/70" data-id="element-1385" data-mp="33e4cf8wkdgxm">•••• •••• 4127</p>
      </div>
    </section>;
}